export default function DownArrow() {
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.34046 10.6926L2.14396 5.89582C1.64871 5.33144 2.05121 4.44507 2.80284 4.44507H11.1958C11.3641 4.44492 11.5287 4.49327 11.6702 4.58432C11.8116 4.67536 11.9238 4.80525 11.9934 4.95842C12.0629 5.1116 12.0868 5.28157 12.0622 5.44797C12.0376 5.61438 11.9656 5.77017 11.8547 5.89669L7.65821 10.6917C7.57608 10.7857 7.4748 10.861 7.36116 10.9126C7.24752 10.9642 7.12415 10.9909 6.99934 10.9909C6.87453 10.9909 6.75116 10.9642 6.63752 10.9126C6.52388 10.861 6.42259 10.7857 6.34046 10.6917V10.6926Z"
        fill="currentColor"
      />
    </svg>
  );
}
